import { useBreakpointV2 } from "@tm/ui-widgets";
import { ImageTag } from "@tm/ui-widgets/components";
import { OfferItemStyle } from "./ExclusiveOffers.style";

interface OfferItemProp {
  cta: {
    url: string;
    type: string;
  };
  image_url: string;
  handleClickOfferItem: () => void;
  offerItemLength?: number;
}
const aspectRatio = 286 / 180;
const OfferItem = ({
  cta,
  image_url,
  handleClickOfferItem,
  offerItemLength,
}: OfferItemProp) => {
  const device = useBreakpointV2();
  return (
    <OfferItemStyle
      onClick={handleClickOfferItem}
      href={cta.url}
      rel="noreferrer"
      target="_blank"
      singleItem={offerItemLength == 1 && device == "sm"}
    >
      <ImageTag src={image_url} width="100%" height="100%" />
    </OfferItemStyle>
  );
};

export default OfferItem;
